export default "__VITE_ASSET__D0S5eV2d__"